import {
  ExportAsyncJob,
  ExportQueryV2 as QueryV2,
} from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/types';

export interface ExportJobStateParams {
  onExportEnd: (params: {
    job: ExportAsyncJob | null;
    query: QueryV2;
    result: 'success' | 'fail' | 'stopped by user';
    saveAs?: string;
  }) => void;
  query: QueryV2;
  saveAs?: string;
}
